import { PropsWithChildren, ReactNode } from 'react';
import { useFeatureFlags } from '../../../services/featureFlags/hooks/useFeatureFlags';

type Props = PropsWithChildren<{
  altDisplay?: ReactNode;
}>;

/**
 * Conditionally render Diagnostic components based on the view mode
 */
export const DiagnosticFeature = ({ children, altDisplay }: Props) => {
  const { Diagnostics } = useFeatureFlags();

  return Diagnostics ? children : altDisplay;
};
